export default __webpack_public_path__ + "static/media/batchFilledIcon.f2598dc3.svg";